import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { toast } from "sonner";

const METRICS = [
  { key: "organizations", label: "Organizations" },
  { key: "users", label: "Users" },
  { key: "platform_admins", label: "Platform Admins" },
  { key: "memberships", label: "Memberships" },
  { key: "social_accounts", label: "Social Accounts" },
  { key: "ecommerce_connections", label: "Ecommerce Connections" },
  { key: "api_keys", label: "API Keys" },
  { key: "social_posts", label: "Social Posts" },
  { key: "campaigns", label: "Campaigns" },
  { key: "promotions", label: "Promotions" },
  { key: "knowledge_bases", label: "Knowledge Bases" },
];

export default function AdminSystem() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/system")
      .then((r) => setData(r.data))
      .catch((e) => toast.error(apiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-system-page">
      <PageHeader title="System" subtitle="Platform-wide totals across all tenants." />
      {loading ? (
        <p className="font-mono text-sm text-muted-foreground">Loading…</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {METRICS.map((m) => (
            <div key={m.key} className="bg-card border border-border rounded-sm p-5" data-testid={`admin-system-${m.key}`}>
              <p className="text-3xl font-heading tabular-nums">{data?.[m.key] ?? 0}</p>
              <p className="text-xs text-muted-foreground uppercase tracking-wide mt-1">{m.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
